import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Input, message, Modal, Typography} from 'antd';
import {projectsApi, type ProjectResponse} from '@/api/projects';

const {Text} = Typography;

interface ICreateProjectProps {
	modalOpen: boolean | undefined;
	setModalOpen: (value: boolean) => void;
	onCreated?: (project: ProjectResponse) => void;
}

const CreateProject: React.FC<ICreateProjectProps> = ({modalOpen, setModalOpen, onCreated}) => {
	const navigate = useNavigate();
	const [createName, setCreateName] = React.useState('');
	const [createDescription, setCreateDescription] = React.useState('');
	const [createLoading, setCreateLoading] = React.useState(false);

	const handleCreate = async () => {
		if (!createName.trim()) {
			message.warning('Введите название проекта');
			return;
		}

		setCreateLoading(true);
		const {data, error, status} = await projectsApi.create({
			name: createName.trim(),
			description: createDescription.trim() || undefined,
		});

		setCreateLoading(false);
		if (error) {
			message.error(error.message || 'Ошибка создания проекта');
			return;
		}

		if (status === 201 && data) {
			message.success('Проект создан');
			setModalOpen(false);
			setCreateName('');
			setCreateDescription('');
			if (onCreated) {
				onCreated(data);
			} else {
				navigate(`/projects/${data.id}`);
			}
		}
	};

	return (
		<Modal
			title="Новый проект"
			open={modalOpen}
			onOk={handleCreate}
			onCancel={() => {
				setModalOpen(false);
				setCreateName('');
				setCreateDescription('');
			}}
			confirmLoading={createLoading}
			cancelText="Отменить"
			okText="Создать"
		>
			<div style={{display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16}}>
				<div>
					<Text strong>Название</Text>
					<br />
					<Input
						value={createName}
						onChange={e => setCreateName(e.target.value)}
						placeholder="Название проекта"
						style={{width: '100%', marginTop: 4}}
					/>
				</div>
				<div>
					<Text strong>Описание</Text>
					<br />
					<Input.TextArea
						value={createDescription}
						onChange={e => setCreateDescription(e.target.value)}
						placeholder="Описание (необязательно)"
						rows={3}
						style={{width: '100%', marginTop: 4, resize: 'vertical'}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default CreateProject;
